// extracted by mini-css-extract-plugin
export default {"wrapper":"SuggestedCategories_wrapper__iDCXB"};